import blog1 from "../../../assets/blog1.webp";
import blog2 from "../../../assets/blog2.webp";
import blog3 from "../../../assets/blog3.webp";
import blog4 from "../../../assets/blog4.webp";
import blog5 from "../../../assets/blog5.webp";
import blog6 from "../../../assets/blog6.webp";

const articleData = [
  {
    id: 1,
    img: blog1,
    alt: "Man performing strength training at the gym",
    title: "MAXIMIZE YOUR GYM TIME EFFECTIVELY",
    text: "Making the most of your gym time is essential to achieving your fitness goals. Plan your sessions carefully, set clear objectives, and focus on exercises that align with your targets, whether it's building strength or improving endurance. Incorporate a proper warm-up and cooldown to avoid injuries and boost recovery. Stay consistent, eat a balanced diet, and prioritize rest for optimal results. Fitness success is built on daily effort and dedication.",
    highlight:
      "Success is a journey, not a destination—embrace every workout as a step forward.",
    text2:
      "Begin your fitness journey with clear objectives, proper planning, and tailored exercises. Remember to warm up and cool down to prevent injuries and enhance performance. Nutrition and recovery play a pivotal role in your progress, so don't overlook these factors. Stay patient, persistent, and celebrate small wins on your way to achieving your fitness aspirations.",
  },
  {
    id: 2,
    img: blog2,
    alt: "Woman focused during a workout",
    title: "ALL YOU NEED TO KNOW ABOUT FITNESS",
    text: "Understanding the fundamentals of fitness is the first step toward a healthier lifestyle. From workout routines to nutrition and wellness trends, this guide provides you with the knowledge needed to make informed decisions. Equip yourself with the tools to succeed and create a fitness journey that's tailored to your needs.",
    highlight:
      "Consistency and knowledge are the cornerstones of fitness success.",
    text2:
      "Explore the key aspects of fitness, including tailored workout plans and smart dietary choices. Stay informed about the latest trends and techniques to maximize your results. With consistency and dedication, you'll pave the way for a healthier, more active life.",
  },
  {
    id: 3,
    img: blog3,
    alt: "Woman lifting weights",
    title: "FITNESS: A PATH TO A SHARPER MIND",
    text: "Regular physical activity does wonders for your mental and emotional well-being. It reduces stress, enhances mood, and boosts cognitive functions. Discover how making fitness a part of your lifestyle can transform not just your body, but also your mind.",
    highlight: "Fitness is not just physical—it's mental and emotional too.",
    text2:
      "Incorporate regular workouts into your routine to benefit both your body and mind. Exercise releases endorphins that elevate your mood and sharpen cognitive abilities, helping you approach challenges with clarity and positivity.",
  },
  {
    id: 4,
    img: blog4,
    alt: "Man starting his fitness journey",
    title: "START YOUR FITNESS JOURNEY TODAY",
    text: "There’s no better time than today to take the first step toward a healthier you. Procrastination holds you back from reaping the benefits of fitness. Start small, stay consistent, and watch as your life transforms.",
    highlight:
      "Today is the perfect day to make fitness a priority—don't wait for tomorrow.",
    text2:
      "Delaying your fitness journey only postpones your progress. Begin today, and set the foundation for a healthier, more fulfilling future. Small steps lead to significant results.",
  },
  {
    id: 5,
    img: blog5,
    alt: "Woman performing bodyweight exercises",
    title: "PERSONAL TRAINING: WHERE TO BEGIN",
    text: "Starting your personal fitness journey can be daunting, but this guide simplifies the process. Learn how to set realistic goals, create effective workout plans, and build a foundation for long-term success.",
    highlight:
      "Your fitness journey begins with a single step in the direction of your goals.",
    text2:
      "Tailor your fitness plan to your needs and preferences. Understand the basics, focus on consistency, and prioritize your health. This is your guide to a sustainable and rewarding fitness journey.",
  },
  {
    id: 6,
    img: blog6,
    alt: "Man training like a pro athlete",
    title: "TRAIN LIKE A CHAMPION",
    text: "Discover the rigorous training, disciplined nutrition, and mental focus that define champions. Adopting these habits can elevate your fitness routine and help you achieve peak performance.",
    highlight: "To train like a champion, think like one first.",
    text2:
      "Understand the mindset and habits of elite athletes. Embrace disciplined training, balanced nutrition, and mental resilience to push your limits and achieve your goals.",
  },
];

export default articleData;
